import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { responsiveFlavors as ResponsiveFlavorsPropType } from 'lib/CustomPropTypes';

import NativeLazyLoad from 'components/NativeLazyLoad';
import ImageCredit from 'components/ImageCredit';
import Picture from 'components/Picture';
import Placeholder from 'components/Picture/Placeholder';

import styles from './styles.module.scss';

const TeasePicture = ({
  responsiveFlavors,
  className,
  lazyload,
  previewRedirect,
  type,
  height,
  width,
  ...remainingProps
}, context = {}) => {
  if (!responsiveFlavors) return null;

  const {
    computedValues,
    placeholder,
    placeholderColor,
  } = remainingProps;

  const {
    teaseImage,
  } = computedValues || {};

  if (!teaseImage && placeholder) {
    return (
      <Placeholder
        responsiveFlavors={responsiveFlavors}
        color={placeholderColor}
      />
    );
  }

  let pictureHeight;
  let pictureWidth;
  if (height && width) {
    pictureHeight = height;
    pictureWidth = width;
  } else if (teaseImage?.height && teaseImage?.width) {
    pictureHeight = teaseImage.height;
    pictureWidth = teaseImage.width;
  }

  const { isFirstLayoutWithPackages } = context;
  const lazyloaded = lazyload && !isFirstLayoutWithPackages;

  let picture = (
    <Picture
      className={classNames(
        'teasePicture',
        styles.container,
        { [className]: className },
      )}
      lazyloaded={lazyloaded}
      responsiveFlavors={responsiveFlavors}
      originalHeight={pictureHeight}
      originalWidth={pictureWidth}
      {...remainingProps}
    />
  );

  if (lazyloaded) {
    picture = (
      <NativeLazyLoad
        placeholder={placeholder}
        placeholderColor={placeholderColor}
      >
        {picture}
      </NativeLazyLoad>
    );
  }

  return (
    <>
      {picture}
      <ImageCredit
        type={type}
        responsiveFlavors={responsiveFlavors}
        {...remainingProps}
      />
    </>
  );
};

TeasePicture.contextTypes = {
  isFirstLayoutWithPackages: PropTypes.bool,
};

TeasePicture.propTypes = {
  responsiveFlavors: ResponsiveFlavorsPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  lazyload: PropTypes.bool,
  placeholder: PropTypes.bool,
  previewRedirect: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

TeasePicture.defaultProps = {
  responsiveFlavors: {},
  className: null,
  type: null,
  lazyload: true,
  placeholder: false,
  previewRedirect: true,
  height: null,
  width: null,
};

export default TeasePicture;
